// import { UserResource } from './resources'
import axios from 'axios';
import { EventBus } from '@/event-bus';
import { API_ROOT } from '../config';
import router from '../_router';

const api = axios.create({
  baseURL: API_ROOT,
});

api.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const session = localStorage.getItem('session');
  config.headers = {
    ...config.headers,
  };
  if (user && user.token) {
    config.headers.Authorization = `Token ${user.token}`;
  }
  if (session) {
    config.headers['X-Session'] = session;
  }
  // console.log("CONFOIG", session)
  // console.log(config)
  /** If cancel token present in params, move it to the parent */
  if (config.params?.cancelToken && !config.cancelToken) {
    const { cancelToken, ...kwargs } = config.params;
    config.params = kwargs;
    config.cancelToken = cancelToken;
  }
  return config;
});

api.interceptors.response.use((response) => response, (error) => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (error.response && error.response.status === 401) {
    console.log('Invalid session', error.response);
    const email_user = user.user.email;
    const domain_user = email_user.substring(email_user.lastIndexOf('@') + 1);
    if (domain_user === 'burberry.com') {
      EventBus.$emit('confirm', {
        title: 'Expired Session',
        message: 'Your session is expiring. Please re-authenticate to continue working.',
        positiveText: 'Authenticate',
        callback: (confirm) => {
          if (confirm) {
            router.push('/login');
          }
        },
        showCancel: false,
        showCloseButton: false,
      });
    } else {
      router.push('/login');
    }
  }
  return Promise.reject(error);
});

export default api;
